@if (text() && value()) {
	<span class="Pill Pill--{{ value() }}" [class.Pill--full]="full()">
		{{ text() }}
	</span>
} @else {
	@if (value() === '-') {
		<span class="Pill Pill--none">
			{{ value() }}
		</span>
	} @else if (value()) {
		<span class="Pill Pill--{{ value() }}" [class.Pill--full]="full()">
			{{ value() | titleCaseNumber }}
		</span>
	} @else {
		<span class="Pill"> state empty</span>
	}
}
